import React from 'react';
import { Icon } from './Icon.js';
export const IconBooleanFlatten = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 8L8 8L8.5 8", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M16 3V16V15.5", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M3 3L21 21", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M16 3L3 3V16H8V21L21 21L21 8", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconBooleanFlatten.js.map